module.exports = __webpack_public_path__ + "static/logo-5ae0b7f236c16179bf6e9db1f091db2c.png";